import { Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { Button, BUTTON } from 'components/common/Button/Button';
import ReportDialogTitle from 'pages/report/components/ReportDialogTitle';
import styles from 'pages/report/components/ReportDialogs.scss';

export default function DialogDeactivateUser ({ isOpen, handleOnClose, handleConfirm, taskCount }) {
    return (
        <Dialog
            open={isOpen}
            onClose={handleOnClose}
            fullWidth
            aria-labelledby="form-dialog-title"
            className={styles.dialogContainer}
        >
            <ReportDialogTitle onClose={handleOnClose} children={'Deactivate User'} />
            <DialogContent>
                <Typography gutterBottom>
                    {`This user is currently assigned to ${taskCount} outstanding tasks. These tasks will be cancelled if this
                        user is deactivated.`}
                </Typography>
                <Typography gutterBottom>Are you sure you want to proceed?</Typography>
            </DialogContent>
            <DialogActions className={styles.dialogAction}>
                <Button
                    className={styles.btnOutline}
                    onClick={handleOnClose}
                    bgcolor={BUTTON.BGCOLOR.CLEAR}
                    color={BUTTON.COLOR.GREY}
                    text={'Cancel'}
                    data-cy="DialogDeactivateUser-Cancel"
                />
                <Button
                    onClick={handleConfirm}
                    bgcolor={BUTTON.BGCOLOR.ORANGE}
                    color={BUTTON.COLOR.WHITE}
                    text={'Confirm'}
                    data-cy="DialogDeactivateUser-Confirm"
                />
            </DialogActions>
        </Dialog>
    );
}
